
import { defineComponent } from 'vue'
import PatientSummary from '../shared/PatientSummary.vue'

export default defineComponent({
  name: 'EncounterDetail',
  props: ['patient', 'encounter'], 
  components: {
    PatientSummary,
  },
  data () {
    return {
      encounterTypeItems: ['Inpatient', 'Outpatient', 'Day Surgery', 'Emergency'],
      visitTypeItems: ['Admission', 'Procedure', 'Consultation'],
      movementTypeItems: ['Fist Visit', 'Repeat Visit', 'Admission', 'Readmission'],
      locationItems: ['Ward 12', 'Eye Clinic', 'Procedure 123'],
      patientClassItems: ['Private', 'Subsidised'],
      accomodationItems: ['1 Bedder', '2 Bedder', '4 Bedder', '6 Bedder', 'Other'],
      patientSummary: {
        name: 'Strawberry Shortcake Jamz',
        birthdate: '01 Jan 1980',
        age: '43',
        location: 'Ward 12',
        hrn: 332211
      },
      admissionDate: new Date().toISOString().substr(0, 10)
    }
  },
  computed: {
    visit: {
      get () {
        return this.encounter
      },
      set (value) {
        this.$emit('updateEncounter', value)
      }
    }
  }

})
